<div ngbAccordion #OuterAccordion="ngbAccordion"
  class="custom-collapse">
  @for (group of groups; track trackByCustomDate($index, group)) {
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <span class="lead collapse-title group-header-container f-gap-small">
            <div class="custom-control custom-checkbox not-fixed-width"
              (click)="$event.stopPropagation()">
              <input type="checkbox"
                class="custom-control-input"
                [id]="componentId + '-grp-cust-' + group.customDate"
                [checked]="areAllGroupItemsSelected(group.itemIndexes)"
                (change)="onToggleGroupSelectAll(group.itemIndexes, $event)" />
                <label class="custom-control-label"
                [for]="componentId + '-grp-cust-' + group.customDate"></label>
              </div>
              <div class="truncate flex-1">
                <div class="bold-text">{{'MENU.CUSTOM_DATE' | translate}}</div>
                <div class="margin-top-small">{{group.customDate | date:'d MMM y'}}</div>
              </div>
              <div class="truncate flex-1">
                <div class="bold-text">{{'CUSTOM_SHIP_DATES.QTY' | translate}}</div>
                <div class="margin-top-small">{{group.totalQtyForDate}}</div>
              </div>
              <div class="truncate flex-1">
                <div class="bold-text">{{'MENU.BY_DATE' | translate}}</div>
                @if (isSingleDate(group.minRequestedDeliveryDate, group.maxRequestedDeliveryDate)) {
                  <div class="margin-top-small"
                    >
                    {{group.minRequestedDeliveryDate | date:'d MMM y'}}
                  </div>
                }
                @if (!isSingleDate(group.minRequestedDeliveryDate, group.maxRequestedDeliveryDate)) {
                  <div class="margin-top-small"
                    >
                    {{'CUSTOM_SHIP_DATES.FROM' | translate}} {{group.minRequestedDeliveryDate | date:'d MMM y'}}
                    {{'CUSTOM_SHIP_DATES.TO' | translate}} {{group.maxRequestedDeliveryDate | date:'d MMM y'}}
                  </div>
                }
              </div>
              <div class="truncate flex-1">
                <div class="bold-text">{{'CUSTOM_SHIP_DATES.N_ORDER_ITEMS' | translate}}</div>
                <div class="margin-top-small">{{group.nOrderItems}}</div>
              </div>
            </span>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <app-items-table [itemIndexes]="group.itemIndexes"
                [filterCustomDate]="group.customDate"
                [orderItemsFormCustomDate]="orderItemsFormCustomDate"
                [supportsSplitDelivery]="supportsSplitDelivery"
                [showStockQty]="showStockQty"
                [maxStoreCustomDate]="maxStoreCustomDate"
                [componentId]="componentId"
                [idPrefix]="'-cust-'"
                (dateAdded)="dateAdded.emit($event)"
                (stockDateAdded)="stockDateAdded.emit($event)"
                (customDateCleared)="customDateCleared.emit($event)"
                (dateRemoved)="dateRemoved.emit($event)"
                (dateTimeChanged)="dateTimeChanged.emit($event)">
              </app-items-table>
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
